// src/components/MenuItem.js
import React, { useState,useEffect } from 'react';
import { Link } from 'react-router-dom';
const ApplicationMenuItem = ({ item,closemenu }) => {
    const [activeMenuchild, setActiveMenuchild] = useState(null);
  const hasChildren = item.subCategories && item.subCategories.length > 0;
const handleClick = () => {
    // ❗ Only close menu if NO children
    if (!hasChildren  && closemenu) {
      closemenu();
    }
  };
  return (
    <li id={`menu-item-${item.id}`} className={`${hasChildren ? 'menu-item menu-item-type-post_type menu-item-object-page menu-item-has-children' : 'menu-item menu-item-type-custom menu-item-object-custom'} ${activeMenuchild === `menu-item-${item.id}` ? 'active' : ''} menu-item-${item.id}`} onMouseEnter={() => setActiveMenuchild(`menu-item-${item.id}`)} onMouseLeave={() => setActiveMenuchild(null)}>
       <Link className="dropdown-trigger" to={'applications/'+item.url} onClick={handleClick}>{item.name}</Link>
      {/* <a href={item.url}>{item.title}</a> */}
      {hasChildren && (
        <ul className='sub-menu with-scroll'>
          {item.subCategories.map((child) => (
            <ApplicationMenuItem key={child.id} item={child} closemenu={closemenu} />
          ))}
        </ul>
      )}
    </li>
  );
};

export default ApplicationMenuItem;
